// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Primary */
  --primary: #4F46E5;
  --primary-light: #EEF2FF;
  --primary-hover: #4338CA;
  --primary-50: #E0E7FF;

  /* Backgrounds */
  --bg: #F8FAFC;
  --bg-card: #FFFFFF;
  --bg-elevated: #FFFFFF;

  /* Borders */
  --border: #E2E8F0;
  --border-light: #F1F5F9;

  /* Text */
  --text-primary: #1E293B;
  --text-secondary: #64748B;
  --text-muted: #94A3B8;

  /* Status */
  --success: #22C55E;
  --success-light: #F0FDF4;
  --success-disabled: #69c98c;
  
  --warning: #F59E0B;
  --warning-light: #FFFBEB;
  --danger: #EF4444;
  --danger-light: #FEF2F2;

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -2px rgba(0, 0, 0, 0.05);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.04);

  /* Radius */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
  --radius-xl: 20px;

  /* Transitions */
  --transition-fast: 0.15s ease;
  --transition-normal: 0.2s ease;
  --transition-slow: 0.3s ease;
}

/* Dark Mode */
[data-theme="dark"] {
  --primary: #818CF8;
  --primary-light: rgba(129, 140, 248, 0.12);
  --primary-hover: #A5B4FC;
  --primary-50: rgba(129, 140, 248, 0.2);

  --bg: #0F172A;
  --bg-card: #1E293B;
  --bg-elevated: #334155;

  --border: #334155;
  --border-light: #1E293B;

  --text-primary: #F1F5F9;
  --text-secondary: #94A3B8;
  --text-muted: #64748B;

  --success: #4ADE80;
  --success-light: rgba(74, 222, 128, 0.12);
  --warning: #FBBF24;
  --warning-light: rgba(251, 191, 36, 0.12);
  --danger: #F87171;
  --danger-light: rgba(248, 113, 113, 0.12);

  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -2px rgba(0, 0, 0, 0.3);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -4px rgba(0, 0, 0, 0.4);

  color-scheme: dark;
}

html {
  height: 100%;
}

html[data-theme="dark"] *,
html[data-theme="light"] * {
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  color: var(--text-primary);
  line-height: 1.5;
  background-color: var(--bg);
  font-size: 14px;
}

#root {
  height: 100% !important;
}

div.App {
  min-height: 100vh;
  overflow-y: hidden;
}

code {
  font-family: 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

* {
  box-sizing: border-box;
}

button {
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  transition: all var(--transition-fast);
}

button:focus {
  animation: none;
}

button:active {
  transform: scale(0.98);
}

input, select, textarea {
  font-family: inherit;
  font-size: 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 8px 12px;
  color: var(--text-primary);
  background-color: var(--bg-card);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  outline: none;
}

input:focus, select:focus, textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
}

input::placeholder, textarea::placeholder {
  color: var(--text-muted);
}

a {
  color: var(--primary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

a:hover {
  color: var(--primary-hover);
}

/* Utility classes */
.flexbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.error_component {
  background-color: var(--danger-light);
  color: var(--danger);
  padding: 12px 16px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--danger);
  font-size: 13px;
  font-weight: 500;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}

/* Global button styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
}

.btn-primary {
  background-color: var(--primary);
  color: white;
}

.btn-primary:hover {
  background-color: var(--primary-hover);
  box-shadow: var(--shadow-sm);
}

.btn-secondary {
  background-color: var(--bg);
  color: var(--text-primary);
  border: 1px solid var(--border);
}

.btn-secondary:hover {
  background-color: var(--border-light);
  border-color: var(--border);
}

.btn-danger {
  background-color: var(--danger);
  color: white;
}

.btn-danger:hover {
  background-color: #DC2626;
}

/* Selection */
::selection {
  background-color: var(--primary-light);
  color: var(--primary);
}

/* ===== Dark Mode Global Fixes ===== */

/* Ensure ALL text elements inherit proper color in dark mode */
[data-theme="dark"] h1,
[data-theme="dark"] h2,
[data-theme="dark"] h3,
[data-theme="dark"] h4,
[data-theme="dark"] h5,
[data-theme="dark"] h6 {
  color: var(--text-primary);
}

[data-theme="dark"] p,
[data-theme="dark"] span,
[data-theme="dark"] label,
[data-theme="dark"] td,
[data-theme="dark"] th,
[data-theme="dark"] li,
[data-theme="dark"] div {
  color: inherit;
}

/* Fix select/option dark mode */
[data-theme="dark"] select option {
  background-color: var(--bg-card);
  color: var(--text-primary);
}

/* Fix any remaining hardcoded dark colors in dark mode */
[data-theme="dark"] .custom-select {
  background-color: var(--bg-card);
  color: var(--text-primary);
  border-color: var(--border);
}

/* Fix table global styles for dark mode */
[data-theme="dark"] table {
  color: var(--text-primary);
}

[data-theme="dark"] td {
  color: var(--text-primary);
}

[data-theme="dark"] th {
  color: var(--text-secondary);
}

/* Fix hr elements */
hr {
  border: none;
  border-top: 1px solid var(--border-light);
  margin: 8px 0;
}

/* Fix react-datepicker dark mode */
[data-theme="dark"] .react-datepicker {
  background-color: var(--bg-card);
  border-color: var(--border);
  color: var(--text-primary);
}

[data-theme="dark"] .react-datepicker__header {
  background-color: var(--bg-elevated) !important;
  border-bottom-color: var(--border);
}

[data-theme="dark"] .react-datepicker__current-month,
[data-theme="dark"] .react-datepicker__day-name,
[data-theme="dark"] .react-datepicker__day {
  color: var(--text-primary);
}

[data-theme="dark"] .react-datepicker__day:hover {
  background-color: var(--primary-light);
}

[data-theme="dark"] .react-datepicker__day--selected {
  background-color: var(--primary);
  color: white;
}

/* Badge dark mode fix - ensure white text on colored badges */
[data-theme="dark"] .badge {
  opacity: 0.9;
}

/* Recharts dark mode fixes */
[data-theme="dark"] .recharts-cartesian-axis-tick-value {
  fill: var(--text-secondary) !important;
}
[data-theme="dark"] .recharts-cartesian-grid line {
  stroke: var(--border) !important;
}
[data-theme="dark"] .recharts-tooltip-wrapper .recharts-default-tooltip {
  background-color: var(--bg-card) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}
[data-theme="dark"] .recharts-legend-item-text {
  color: var(--text-secondary) !important;
}
[data-theme="dark"] .recharts-label {
  fill: var(--text-secondary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;;EAErB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;;EAEtB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;;EAEvB,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;;EAE3B,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;;EAEvB,YAAY;EACZ,0CAA0C;EAC1C,mFAAmF;EACnF,qFAAqF;;EAErF,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,wBAAwB;EACxB,sCAAsC;;EAEtC,aAAa;EACb,kBAAkB;EAClB,sBAAsB;;EAEtB,iBAAiB;EACjB,uBAAuB;;EAEvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,yCAAyC;;EAEzC,yCAAyC;EACzC,iFAAiF;EACjF,mFAAmF;;EAEnF,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gEAAgE;AAClE;;AAEA;EACE,SAAS;EACT,yFAAyF;EACzF,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;EAChC,kFAAkF;EAClF,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA,uCAAuC;;AAEvC,+DAA+D;AAC/D;;;;;;EAME,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,yDAAyD;AACzD;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,yCAAyC;EACzC,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,qCAAqC;AACvC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\n:root {\n  /* Primary */\n  --primary: #4F46E5;\n  --primary-light: #EEF2FF;\n  --primary-hover: #4338CA;\n  --primary-50: #E0E7FF;\n\n  /* Backgrounds */\n  --bg: #F8FAFC;\n  --bg-card: #FFFFFF;\n  --bg-elevated: #FFFFFF;\n\n  /* Borders */\n  --border: #E2E8F0;\n  --border-light: #F1F5F9;\n\n  /* Text */\n  --text-primary: #1E293B;\n  --text-secondary: #64748B;\n  --text-muted: #94A3B8;\n\n  /* Status */\n  --success: #22C55E;\n  --success-light: #F0FDF4;\n  --success-disabled: #69c98c;\n  \n  --warning: #F59E0B;\n  --warning-light: #FFFBEB;\n  --danger: #EF4444;\n  --danger-light: #FEF2F2;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -2px rgba(0, 0, 0, 0.05);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.04);\n\n  /* Radius */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  --radius-xl: 20px;\n\n  /* Transitions */\n  --transition-fast: 0.15s ease;\n  --transition-normal: 0.2s ease;\n  --transition-slow: 0.3s ease;\n}\n\n/* Dark Mode */\n[data-theme=\"dark\"] {\n  --primary: #818CF8;\n  --primary-light: rgba(129, 140, 248, 0.12);\n  --primary-hover: #A5B4FC;\n  --primary-50: rgba(129, 140, 248, 0.2);\n\n  --bg: #0F172A;\n  --bg-card: #1E293B;\n  --bg-elevated: #334155;\n\n  --border: #334155;\n  --border-light: #1E293B;\n\n  --text-primary: #F1F5F9;\n  --text-secondary: #94A3B8;\n  --text-muted: #64748B;\n\n  --success: #4ADE80;\n  --success-light: rgba(74, 222, 128, 0.12);\n  --warning: #FBBF24;\n  --warning-light: rgba(251, 191, 36, 0.12);\n  --danger: #F87171;\n  --danger-light: rgba(248, 113, 113, 0.12);\n\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -2px rgba(0, 0, 0, 0.3);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -4px rgba(0, 0, 0, 0.4);\n\n  color-scheme: dark;\n}\n\nhtml {\n  height: 100%;\n}\n\nhtml[data-theme=\"dark\"] *,\nhtml[data-theme=\"light\"] * {\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  min-height: 100%;\n  color: var(--text-primary);\n  line-height: 1.5;\n  background-color: var(--bg);\n  font-size: 14px;\n}\n\n#root {\n  height: 100% !important;\n}\n\ndiv.App {\n  min-height: 100vh;\n  overflow-y: hidden;\n}\n\ncode {\n  font-family: 'JetBrains Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbutton {\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-family: inherit;\n  transition: all var(--transition-fast);\n}\n\nbutton:focus {\n  animation: none;\n}\n\nbutton:active {\n  transform: scale(0.98);\n}\n\ninput, select, textarea {\n  font-family: inherit;\n  font-size: 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 8px 12px;\n  color: var(--text-primary);\n  background-color: var(--bg-card);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  outline: none;\n}\n\ninput:focus, select:focus, textarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n}\n\ninput::placeholder, textarea::placeholder {\n  color: var(--text-muted);\n}\n\na {\n  color: var(--primary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\na:hover {\n  color: var(--primary-hover);\n}\n\n/* Utility classes */\n.flexbox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.error_component {\n  background-color: var(--danger-light);\n  color: var(--danger);\n  padding: 12px 16px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--danger);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--text-muted);\n}\n\n/* Global button styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.5;\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n}\n\n.btn-primary {\n  background-color: var(--primary);\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: var(--primary-hover);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-secondary {\n  background-color: var(--bg);\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n}\n\n.btn-secondary:hover {\n  background-color: var(--border-light);\n  border-color: var(--border);\n}\n\n.btn-danger {\n  background-color: var(--danger);\n  color: white;\n}\n\n.btn-danger:hover {\n  background-color: #DC2626;\n}\n\n/* Selection */\n::selection {\n  background-color: var(--primary-light);\n  color: var(--primary);\n}\n\n/* ===== Dark Mode Global Fixes ===== */\n\n/* Ensure ALL text elements inherit proper color in dark mode */\n[data-theme=\"dark\"] h1,\n[data-theme=\"dark\"] h2,\n[data-theme=\"dark\"] h3,\n[data-theme=\"dark\"] h4,\n[data-theme=\"dark\"] h5,\n[data-theme=\"dark\"] h6 {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] p,\n[data-theme=\"dark\"] span,\n[data-theme=\"dark\"] label,\n[data-theme=\"dark\"] td,\n[data-theme=\"dark\"] th,\n[data-theme=\"dark\"] li,\n[data-theme=\"dark\"] div {\n  color: inherit;\n}\n\n/* Fix select/option dark mode */\n[data-theme=\"dark\"] select option {\n  background-color: var(--bg-card);\n  color: var(--text-primary);\n}\n\n/* Fix any remaining hardcoded dark colors in dark mode */\n[data-theme=\"dark\"] .custom-select {\n  background-color: var(--bg-card);\n  color: var(--text-primary);\n  border-color: var(--border);\n}\n\n/* Fix table global styles for dark mode */\n[data-theme=\"dark\"] table {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] td {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] th {\n  color: var(--text-secondary);\n}\n\n/* Fix hr elements */\nhr {\n  border: none;\n  border-top: 1px solid var(--border-light);\n  margin: 8px 0;\n}\n\n/* Fix react-datepicker dark mode */\n[data-theme=\"dark\"] .react-datepicker {\n  background-color: var(--bg-card);\n  border-color: var(--border);\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .react-datepicker__header {\n  background-color: var(--bg-elevated) !important;\n  border-bottom-color: var(--border);\n}\n\n[data-theme=\"dark\"] .react-datepicker__current-month,\n[data-theme=\"dark\"] .react-datepicker__day-name,\n[data-theme=\"dark\"] .react-datepicker__day {\n  color: var(--text-primary);\n}\n\n[data-theme=\"dark\"] .react-datepicker__day:hover {\n  background-color: var(--primary-light);\n}\n\n[data-theme=\"dark\"] .react-datepicker__day--selected {\n  background-color: var(--primary);\n  color: white;\n}\n\n/* Badge dark mode fix - ensure white text on colored badges */\n[data-theme=\"dark\"] .badge {\n  opacity: 0.9;\n}\n\n/* Recharts dark mode fixes */\n[data-theme=\"dark\"] .recharts-cartesian-axis-tick-value {\n  fill: var(--text-secondary) !important;\n}\n[data-theme=\"dark\"] .recharts-cartesian-grid line {\n  stroke: var(--border) !important;\n}\n[data-theme=\"dark\"] .recharts-tooltip-wrapper .recharts-default-tooltip {\n  background-color: var(--bg-card) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n[data-theme=\"dark\"] .recharts-legend-item-text {\n  color: var(--text-secondary) !important;\n}\n[data-theme=\"dark\"] .recharts-label {\n  fill: var(--text-secondary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
